export default {
  navOpen: false,
  searchOpen: false,
};
